import * as Sentry from "@sentry/browser";

const RAILS_ENV = document.body.dataset.railsEnv;

const REPORT_ERRORS = [
  "production",
  "staging",
  "production_playground",
  "staging_playground",
].includes(RAILS_ENV);

// use proper dsn for playground or learn
const SENTRY_DSN = RAILS_ENV.includes("playground")
  ? "https://852bc7ccd7894e76a96560b2a5e46d8e@sentry.adafruit.us/7"
  : "https://4ba4f3e0239544008c4ba22edc7d6bbd@sentry.adafruit.us/2";

if (REPORT_ERRORS) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: RAILS_ENV,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/configuration/options/#sendDefaultPii
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: ["production", "production_playground"].includes(
      RAILS_ENV,
    )
      ? 0.5
      : 1.0,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
